import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../hooks/useAdminAuth";
import { Flex, Spinner } from "@chakra-ui/react";

export default function AdminRoute({ children }) {
  const { isAdmin, isLoaded } = useAdminAuth();

  if (!isLoaded) {
    return (
      <Flex h="100vh" align="center" justify="center" bg="gray.50">
        <Spinner size="xl" color="orange.500" />
      </Flex>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
